import React from "react";
import { motion } from "framer-motion";
import Project from "./Project";

const NewProjects = () => {
  return (
    <section
      id="projects"
      className="relative max-w-screen-xl mx-auto px-4 md:px-6 lg:px-8 pt-16 sm:pt-20 pb-12 sm:pb-20"
    >
      {/* Ambient orbs */}
      <div className="pointer-events-none absolute top-0 right-0 w-96 h-96 rounded-full bg-[radial-gradient(circle,#ff014f0c,transparent_55%)] blur-3xl" />
      <div className="pointer-events-none absolute top-1/3 left-0 w-72 h-72 rounded-full bg-[radial-gradient(circle,#6366f10c,transparent_55%)] blur-3xl" />

      <div className="relative flex flex-col items-center text-center mb-12 sm:mb-16">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5, ease: [0.25, 1, 0.5, 1] }}
          className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-xs font-medium uppercase tracking-[0.2em] text-gray-400 backdrop-blur-md mb-5"
        >
          <span className="h-2 w-2 rounded-full bg-designColor animate-pulse" />
          What I&apos;ve built
        </motion.div>
        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5, delay: 0.08, ease: [0.25, 1, 0.5, 1] }}
          className="text-4xl sm:text-5xl md:text-6xl font-bold text-white tracking-tight"
        >
          <span className="bg-gradient-to-r from-white via-gray-200 to-gray-400 bg-clip-text text-transparent">
            Projects
          </span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5, delay: 0.14, ease: [0.25, 1, 0.5, 1] }}
          className="mt-3 text-gray-400 text-sm sm:text-base max-w-md"
        >
          Selected work across web, mobile, and full-stack
        </motion.p>
      </div>

      <Project />
    </section>
  );
};

export default NewProjects;
